export default __webpack_public_path__ + "static/media/desc-sub-banner-4.8dcb34ea.svg";